import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70a803e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "wrapper"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-back" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, " Change Password ", -1))
const _hoisted_4 = { class: "hint" }
const _hoisted_5 = {
  key: 0,
  class: "error-box"
}
const _hoisted_6 = {
  key: 1,
  class: "d-wrapper"
}
const _hoisted_7 = { class: "pass-change-wrapper" }
const _hoisted_8 = { class: "left" }
const _hoisted_9 = { class: "d-aside" }
const _hoisted_10 = { class: "d-aside__main-menu" }
const _hoisted_11 = { class: "right" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-close" }, null, -1))
const _hoisted_13 = { class: "hint" }
const _hoisted_14 = {
  key: 0,
  class: "error-box"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_app_input = _resolveComponent("app-input")!
  const _component_app_alert = _resolveComponent("app-alert")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_Form = _resolveComponent("Form")!
  const _component_desktop_header = _resolveComponent("desktop-header")!
  const _component_drive_aside_main_menu = _resolveComponent("drive-aside-main-menu")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_app_header, { class: "header" }, {
          "top-left": _withCtx(() => [
            _createVNode(_component_router_link, {
              to: "/settings",
              class: "back-link"
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          "top-middle": _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$localize('settings.change.password.hint')), 1),
        _createVNode(_component_Form, {
          as: "el-form",
          "validation-schema": _ctx.schema,
          onSubmit: _ctx.onSubmit,
          class: "form"
        }, {
          default: _withCtx(({errors}) => [
            _createVNode(_component_app_input, {
              type: "password",
              name: "password",
              onFocus: _cache[0] || (_cache[0] = ($event: any) => (_ctx.errorCurrentPassword = '')),
              "prop-error": _ctx.errorCurrentPassword,
              clearable: "",
              "show-password": "",
              label: _ctx.$localize('settings.change.password.input1')
            }, null, 8, ["prop-error", "label"]),
            _createVNode(_component_app_input, {
              type: "password",
              name: "newPassword",
              onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.errorNewPassword = '')),
              "prop-error": _ctx.errorNewPassword,
              clearable: "",
              "show-password": "",
              label: _ctx.$localize('settings.change.password.input2')
            }, null, 8, ["prop-error", "label"]),
            _createVNode(_component_app_input, {
              type: "password",
              name: "confirmation",
              onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.errorConfirmPassword = '')),
              "prop-error": _ctx.errorConfirmPassword,
              clearable: "",
              "show-password": "",
              label: _ctx.$localize('settings.change.password.input3')
            }, null, 8, ["prop-error", "label"]),
            (_ctx.errorKey)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_app_alert, {
                    title: _ctx.errorKey,
                    closable: false,
                    center: true,
                    type: "error"
                  }, null, 8, ["title"])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_app_button, {
              disabled: !!errors.password,
              type: "primary",
              "native-type": "submit",
              class: "w-100 el-button-lg",
              round: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('submit.change.password.btn')), 1)
              ]),
              _: 2
            }, 1032, ["disabled"])
          ]),
          _: 1
        }, 8, ["validation-schema", "onSubmit"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
        _createVNode(_component_desktop_header),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("aside", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_drive_aside_main_menu)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_router_link, {
              to: "/settings",
              class: "close"
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$localize('settings.change.password.hint')), 1),
            _createVNode(_component_Form, {
              as: "el-form",
              "validation-schema": _ctx.schema,
              onSubmit: _ctx.onSubmit,
              class: "form"
            }, {
              default: _withCtx(({errors}) => [
                _createVNode(_component_app_input, {
                  type: "password",
                  name: "password",
                  onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.errorCurrentPassword = '')),
                  "prop-error": _ctx.errorCurrentPassword,
                  clearable: "",
                  "show-password": "",
                  label: _ctx.$localize('settings.change.password.input1')
                }, null, 8, ["prop-error", "label"]),
                _createVNode(_component_app_input, {
                  type: "password",
                  name: "newPassword",
                  onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.errorNewPassword = '')),
                  "prop-error": _ctx.errorNewPassword,
                  clearable: "",
                  "show-password": "",
                  label: _ctx.$localize('settings.change.password.input2')
                }, null, 8, ["prop-error", "label"]),
                _createVNode(_component_app_input, {
                  type: "password",
                  name: "confirmation",
                  onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.errorConfirmPassword = '')),
                  "prop-error": _ctx.errorConfirmPassword,
                  clearable: "",
                  "show-password": "",
                  label: _ctx.$localize('settings.change.password.input3')
                }, null, 8, ["prop-error", "label"]),
                (_ctx.errorKey)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createVNode(_component_app_alert, {
                        title: _ctx.errorKey,
                        closable: false,
                        center: true,
                        type: "error"
                      }, null, 8, ["title"])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_app_button, {
                  disabled: !!errors.password,
                  type: "primary",
                  "native-type": "submit",
                  class: "w-100 el-button-lg",
                  round: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$localize('submit.change.password.btn')), 1)
                  ]),
                  _: 2
                }, 1032, ["disabled"])
              ]),
              _: 1
            }, 8, ["validation-schema", "onSubmit"])
          ])
        ])
      ]))
}